<template>
    <div>
    <h1 class="text-center title__gestion">Lista de tareas</h1>
    <hr />

    <!-- //===TABLA====== -->
    <v-card  class="mx-auto mt-100" color="transparent" elevation="0">
        <v-btn 
        type="button" 
        class="mx-2" 
        fab dark color="#1976D2" @click="abrirModal(false)" > <v-icon>mdi-plus</v-icon>
        </v-btn>

        <template v-slot:text>
        <v-text-field
            v-model="search"
            label="Buscar"
            prepend-inner-icon="mdi-magnify"
            variant="outlined"
            hide-details
            single-line ></v-text-field>
        </template>

        <v-data-table :headers="headers" :items="desserts" :search="search">
            <template v-slot:item="props">
                <tr>
                    <td>{{ props.item.placa }}</td>
                    <td>{{ props.item.usuario }}</td>
                    
                    <!-- Campo Piso como Checkbox -->
                    <td>
                        <v-checkbox
                            v-model="props.item.piso"
                            :value="true"
                            :input-value="props.item.piso"
                            :disabled="true">
                            
                        </v-checkbox>
                    </td>

                    <!-- Campo Cocina como Checkbox -->
                    <td>
                        <v-checkbox
                            v-model="props.item.cocina"
                            :value="true"
                            :input-value="props.item.cocina"
                            :disabled="true">
                        </v-checkbox>
                    </td>

                    <!-- Campo Baño como Checkbox -->
                    <td>
                        <v-checkbox
                            v-model="props.item.baño"
                            :value="true"
                            :input-value="props.item.baño"
                            :disabled="true">
                        </v-checkbox>
                    </td>

                    <td>{{ props.item.comentarios }}</td>

                    <td>
                        <!-- Botón de Editar -->
                        <v-btn color="#1976D2" small fab @click="abrirModal(true, props.item)"> 
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
    
    
    <!-- =========MODAL PARA CREAR O EDITAR======================= -->
        <v-dialog v-model="dialog" max-width="600">
            <v-card>
                <v-card-title class="table--title" style="display: flex; align-items: center; justify-content: space-between;">
                    <h4>{{ tituloModal }}</h4>
                    <v-btn @click="cerrarModal" type="button" color="red" fab small dark> X </v-btn>
                </v-card-title>

                <v-card-text></v-card-text>
                <v-container>
                    <v-row>
                        <!-- Select para el Nombre del Usuario -->
                        <v-col cols="12" md="12">

                            <v-select
                                v-model="listaTareas.id_usuario"
                                :items="usuarios"
                                item-title="nombre"  
                                item-value="id_usuario"
                                label="Nombre del usuario"
                                required
                            ></v-select>

                        </v-col>
                      
                        <!-- Select para el Modelo -->
                        <v-col cols="12" md="12">

                            <v-select
                                v-model="listaTareas.id_placa"
                                :items="modelos"
                                item-title="modelo"  
                                item-value="id_placa"
                                label="Nombre de la placa"
                                required
                                :disabled="modificar"
                            ></v-select>

                                
                                <!-- <v-select
                                    v-model="modificar ? listaTareas.id_placa : listaTareas.id_usuario"
                                    :items="modelos"
                                    item-title="modelo"
                                    item-value="id_placa"
                                    label="Nombre de la placa"
                                    required
                                    :disabled="modificar"
                                ></v-select> -->

                        </v-col>
                        

                        <!-- Campo para Piso (Checkbox) -->
                        <v-checkbox
                            v-model="listaTareas.piso"        :label="'Piso'"       color="success"   :disabled="!modificar"> <!-- Deshabilitado si no es edición -->
                        </v-checkbox>

                        <v-checkbox
                            v-model="listaTareas.cocina"       :label="'Cocina'"      color="success"    :disabled="!modificar"> <!-- Deshabilitado si no es edición -->
                        </v-checkbox>

                        <v-checkbox
                            v-model="listaTareas.baño" :label="'Baño'"       color="success"  :disabled="!modificar"> <!-- Deshabilitado si no es edición -->
                        </v-checkbox>




                        <!-- Campo para Comentarios -->
                        <v-col cols="12" md="12">
                            <v-textarea
                                v-model="listaTareas.comentarios"           label="Comentarios"        placeholder="Ingrese comentarios"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-alert v-if="showErrorAlert" text :type="'error'" variant="tonal">
                    {{ errorMessage }}
                </v-alert>

                </v-container>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="cerrarModal();" type="button" color="error">Cancelar</v-btn>
                    <v-btn @click="guardar();" type="submit" color="green darken-1">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>


    <script>
    import axios from "axios";

    export default {
        name:"listaTareas",
    data() {
        return {
            search: '',



            errorMessage: "",  // Mensaje de error
            showErrorAlert: false,  // Controlador para mostrar la alerta



            modificar: true,

            dialog: false,

            tituloModal: '',
            mostrar_error: false,
            // errorApi:'Algo salio mal. Agrega un catalogo de forma de pago diferente',
            timeout: 2000,

            headers: [
                { align: 'start', key: 'placa', sortable: false, title: 'Modelo' },
                // { key: 'placa', title: 'Modelo' },
                { key: 'usuario', title: 'Usuario' },
                { key: 'piso', title: 'Piso' },  
                { key: 'cocina', title: 'Cocina' },  
                { key: 'baño', title: 'Baño' },  
                { key: 'comentarios', title: 'Comentarios' },
                { key: 'acciones', title: 'Acciones', sortable: false }
            ],


            desserts: [],

            usuarios: [],   // Aquí guardaremos los usuarios 

            modelos: [],




        listaTareas: { 
            
            id_usuario: null,  // Debe ser null para evitar problemas
            id_placa: null,    // Asegurar que `placa` es `id_placa`
            // placa: null,    // Asegurar que `placa` es `id_placa`
            piso: false,
            cocina: false,
            baño: false,
            comentarios: '',
        },
        };
    },
    mounted() {
        this.listar();  // Llamamos a listar cuando el componente se monta
        this.cargarUsuarios();
        this.cargarModelos();
    },
    methods: {
        async listar() {
            try {
                const res = await axios.get('https://api.rf8income.com.mx/api/mostrarListaTareas');
                
                // console.log(res.data); // Verifica qué datos estás recibiendo
                // Aseguramos que los valores sean booleanos para los campos 'piso', 'cocina', y 'baño'
                this.desserts = res.data.map(item => ({
                    ...item,
                    piso: item.piso === 1,   // Convertimos 1 a true y 0 a false
                    cocina: item.cocina === 1,
                    baño: item.baño === 1
                }));

            } catch (error) {
                console.error('Error al cargar las placas:', error);
                this.mostrar_error = true;
                this.errorApi = 'Error al cargar los modelos.';
            }
        },
        

        async guardar() {
            // let res;
            console.log("Contenido de listaTareas antes de guardar:", this.listaTareas);

            // if (!this.listaTareas || !this.listaTareas.id) {
            // if (!this.listaTareas || !this.listaTareas.id) {
            //     console.error("No hay datos en listaTareas para guardar.");
            //     return;
            // }

            if (!this.listaTareas || (this.listaTareas.id && !this.listaTareas.id)) {
                console.error("Error: listaTareas o id no está definido.");
                return;
            }

            if (this.modificar) {
                console.log("Editando tarea con ID:", this.listaTareas.id);

                try {
                    const res = await axios.put(`https://api.rf8income.com.mx/api/editarListaTarea/${this.listaTareas.id}`, {
                        id_usuario: this.listaTareas.id_usuario,
                        id_placa: this.listaTareas.id_placa,
                        piso: this.listaTareas.piso ? 1 : 0,
                        cocina: this.listaTareas.cocina ? 1 : 0,
                        baño: this.listaTareas.baño ? 1 : 0,
                        comentarios: this.listaTareas.comentarios || "",
                    });

                    console.log("Tarea editada correctamente:", res.data);
                    this.listar();
                    this.cerrarModal();
                } catch (error) {
                    console.error("Error al editar la tarea:", error.response?.data || error);
                }




    } else {

        //================== PARA CREAR UNA NUEVA TAREA ==================

        console.log("Creando nueva tarea con datos:", JSON.parse(JSON.stringify(this.listaTareas)));

    // Extraer valores para evitar problemas con Proxy de Vue
    const { id_usuario, id_placa, piso, cocina, baño, comentarios } = this.listaTareas;

    // Verificar si los campos requeridos están definidos antes de enviar
    if (!id_usuario || !id_placa) {
        console.error("No se puede agregar la tarea: faltan id_usuario o id_placa.");
        return;
    }

    
    
    console.log("Datos que se enviarán a la API:", {
        id_usuario,
        id_placa,
        piso: piso ? 1 : 0,
        cocina: cocina ? 1 : 0,
        baño: baño ? 1 : 0,
        comentarios: comentarios || "",
    });



    try {
        // Enviar la solicitud POST con los datos de la nueva tarea
        const res = await axios.post("https://api.rf8income.com.mx/api/guardarListaTarea", {
            id_usuario,
            id_placa, // Asegurar que se usa `id_placa` en lugar de `placa`
            piso: piso ? 1 : 0,
            cocina: cocina ? 1 : 0,
            baño: baño ? 1 : 0,
            comentarios: comentarios || "",
        });

        console.log("Tarea agregada correctamente:", res.data);

        this.listar(); // Recargar la lista después de agregar la nueva tarea
        this.cerrarModal(); // Cerrar el modal
    } catch (error) {

        if(error.response && error.response.data.error === 'El modelo ya existe en el catálogo.'){
            this.errorMessage = "El modelo de pidra ya ha sido asignado.";
            this.showErrorAlert = true;  // Mostrar la alerta
        }else{
        console.error("Error al agregar tarea:", error.response?.data || error);
        this.mostrar_error = true;
        this.errorApi = error.response?.data?.error || "Hubo un error al agregar la tarea";
    }
}
}
},


        async cargarUsuarios() {
            try {
                const res = await axios.get('https://api.rf8income.com.mx/api/obtenerUsuariosActivos');
                this.usuarios = res.data.map(user => ({
                    id_usuario: user.id_usuario,
                    nombre: user.nombre
                }));
            } catch (error) {
                console.error("Error al cargar usuarios:", error);
            }
        },
        async cargarModelos() {
            try {
                const res = await axios.get('https://api.rf8income.com.mx/api/obtenerModelosActivos');
                this.modelos = res.data.map(modelo => ({
                    id_placa: modelo.id_placa,
                    modelo: modelo.modelo
                }));
            } catch (error) {
                console.error("Error al cargar usuarios:", error);
            }
        },


        

        verificarSeleccion() {
                console.log("Usuario seleccionado:", this.listaTareas.usuario);
        },
        


        // abrirModal(status, data = {}) {
        //     this.modificar = status;
        //     this.dialog = true;
        

        //     if (status) {
        //         this.cargarUsuarios();
        //         this.listaTareas = { 
        //             id_usuario: data.id_usuario, // ✅ Solo el ID, no el objeto completo
        //             placa: data.placa,
        //             piso: data.piso === true,
        //             cocina: data.cocina === true,
        //             baño: data.baño === true,
        //             comentarios: data.comentarios
        //         };
            
        //         this.tituloModal = 'Editar Tarea';
        //     } else {
        //         this.listaTareas = {
        //             id_usuario: '',
        //             placa: '',
        //             piso: false,
        //             cocina: false,
        //             baño: false,
        //             comentarios: ''
        //         };
        //         this.tituloModal = 'Crear Nueva Tarea';
        //     }
        // },

        abrirModal(status, data = {}) {
            console.log("Datos recibidos para abrir el modal:", data);

            this.modificar = status;
            this.dialog = true;

            if (status) {
                this.cargarUsuarios();
                this.listaTareas = { 
                    id: data.id, // ✅ Agregar el ID
                    id_usuario: data.id_usuario, 
                    id_placa: data.id_placa,
                    piso: data.piso === true,
                    cocina: data.cocina === true,
                    baño: data.baño === true,
                    comentarios: data.comentarios
                };
                this.tituloModal = 'Editar Tarea';
            } else {
                this.listaTareas = {
                    id_usuario: '',
                    id_placa: '',
                    piso: false,
                    cocina: false,
                    baño: false,
                    comentarios: ''
                };
                this.tituloModal = 'Crear Nueva Tarea';
            }
        },



        cerrarModal(){
            this.dialog = false;
            this.errorMessage = "";  // Limpiar el mensaje de error
            this.showErrorAlert = false
        },
        created() {
        this.listar();
        this.cargarUsuarios();
        },



    }
    };
</script>








